export const stepsData = (t) => [
  { step: 1, active: false, name: t('introduction') },
  { step: 2, active: false, name: t('your_hand') },
  { step: 3, active: false, name: t('your_card') },
  { step: 4, active: false, name: t('energy') },
  { step: 5, active: false, name: t('place_your_cards') },
  { step: 6, active: false, name: t('area') },
  { step: 7, active: false, name: t('how_to_win') },
  { step: 8, active: false, name: t('rubik_s_cube') },
  { step: 9, active: false, name: 'SNAP' },
  { step: 10, active: false, name: t('retreat') },
  { step: 11, active: false, name: t('end_the_round') }
];

export const stepsDetail = (t) => {
  const name = t('_marvel_snap_');
  return {
    1: {
      title: t('introduction'),
      text: `${t(
        '{name}_has_both_easy_to_use_gameplay_and_exciting_and_exciting_experience__which',
        { name }
      )}`
    },
    2: {
      title: t('your_hand'),
      text: t('3_cards_are_drawn_from_the_deck_at_the_beginning_of_each_game__then_1_card_is_dr')
    },
    3: {
      title: t('your_card'),
      text: t('the_energy_cost_and_combat_power_of_the_card_will_be_displayed_in_the_upper_left')
    },
    4: {
      title: t('energy'),
      text: t('your_available_energy_is_displayed_at_the_bottom_of_the_screen__for_the_first_tu')
    },
    5: {
      title: t('place_your_cards'),
      text: t('you_need_to_expend_energy_to_place_cards__and_cards_that_are_not_currently_place')
    },
    6: {
      title: t('area'),
      text: t('the_game_features_more_than_80_different_areas__each_with_a_different_effect__an')
    },
    7: {
      title: t('how_to_win'),
      text: t('in_each_area__the_player_with_the_highest_combat_power_will_win__and_the_player_')
    },
    8: {
      title: t('rubik_s_cube'),
      text: t('after_winning_a_qualifying_match__players_receive_a_rubik_s_cube__collecting_rub')
    },
    9: {
      title: 'SNAP',
      text: t('if_you_are_confident_of_winning_the_current_battle__you_can_click_rubik_s_cube_t')
    },
    10: {
      title: t('retreat'),
      text: t('if_you_feel_that_you_are_about_to_lose_the_current_battle__you_can_click_the__re')
    },
    11: {
      title: t('end_the_round'),
      text: t('after_the_operation_is_completed__the_round_can_be_ended!')
    }
  };
};

export const getSpecStyle = (lang) => {
  if (lang === 'ja') {
    return 'spec-ja';
  } else if (lang === 'zh-CN' || lang === 'zh-TW') {
    return 'spec-zh';
  } else if (lang === 'th') {
    return 'spec-th';
  } else if (lang === 'id' || lang === 'it') {
    return 'spec-id';
  } else if (lang === 'ko') {
    return 'spec-kr';
  } else if (lang === 'pt-BR' || lang === 'ru') {
    return 'spec-pt';
  }
  return '';
};

export const getSpecScale = (lang) => {
  if (lang === 'de' || lang == 'es-MX' || lang === 'es-ES' || lang === 'pt-BR' || lang === 'ru') {
    return { transform: 'rotate(5deg) scale(0.55)' };
  }
  return {};
};

export const getSpecLeft = (lang) => {
  if (lang === 'zh-CN' || lang === 'zh-TW' || lang === 'ja' || lang === 'ko') {
    return { left: '0.15rem' };
  } else if (
    lang === 'de' ||
    lang == 'es-MX' ||
    lang === 'es-ES' ||
    lang === 'fr' ||
    lang === 'pt-BR'
  ) {
    return { left: '0rem' };
  }
  return {};
};
